import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Login from '@/components/Login'
import Campaigns from '@/components/Campaigns'
import Playlists from '@/components/Playlists'
import SpotifyAuth from '@/components/SpotifyAuth'
import UserCampaigns from '@/components/UserCampaigns'
import CreateCampaign from '@/components/CreateCampaign'
import Credits from '@/components/Credits'
import Landing from '@/components/Landing'
import UserPlaylists from '@/components/UserPlaylists'
import CreatePlaylist from '@/components/CreatePlaylist'
import MyPlaylistRequests from '@/components/MyPlaylistRequests'
import PlaylistRequest from '@/components/PlaylistRequest'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/landing',
      name: 'Landing',
      component: Landing,
      meta: {
        guest: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/',
      name: 'landing',
      component: Landing,
      meta: {
        guest: true
      }
    },
    {
      path: '/campaigns',
      name: 'Campaigns',
      component: Campaigns,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Playlists',
      name: 'Playlists',
      component: Playlists,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/spotify-auth',
      name: 'SpotifyAuth',
      component: SpotifyAuth,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/campaigns',
      name: 'MyCampaigns',
      component: UserCampaigns,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/campaigns/create',
      name: 'CreateCampaign',
      component: CreateCampaign,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/credits',
      name: 'Credits',
      component: Credits,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/playlists/create',
      name: 'CreatePlaylist',
      component: CreatePlaylist,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/playlists',
      name: 'UserPlaylists',
      component: UserPlaylists,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/playlists/:id',
      name: 'MyPlaylistRequests',
      component: MyPlaylistRequests,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlists/request/:id',
      name: 'PlaylistRequest',
      component: PlaylistRequest,
      meta: {
        requiresAuth: true
      }
    },
    // { path: '*', redirect: '/' }
    { path: '*', redirect: '/landing' }
  ]
})

router.beforeEach(function (to, from, next) {
  window.$('audio').each(item => {
    if (item && item.pause) {
      item.pause()
    }
  })

  window.$('.modal').modal('hide')

  next()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    axios.get(`${window.apiURL}api/user`, { withCredentials: true }).then((response) => {
      if (window.$eventBus) {
        window.$eventBus.$emit('updateUser', response.data)
      }
    }, () => {
      next({
        path: `/login?next=${to.fullPath}`
      })
    })
  }
})

router.afterEach(function (to, from) {
  setTimeout(() => {
    window.ga && window.ga('send', 'pageview', location.pathname + location.search)
  }, 1)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js